<template>
  <select
    v-bind="$attrs"
    :value="modelValue"
    :disabled="disabled"
    :class="[
      'flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground shadow-sm',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
      'disabled:cursor-not-allowed disabled:opacity-50',
      selectClass
    ]"
    @change="$emit('update:modelValue', $event.target.value)"
  >
    <slot />
  </select>
</template>

<script>
export default {
  name: 'UiSelect',
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectClass: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue']
};
</script>
